import styled from "styled-components";

export const MyOrderContainer = styled.div`
	padding: 20px 80px;
`;

export const TitleContainer = styled.h1`
	font-size: 44px;
	color: #762522;
	margin-bottom: 25px;
	h1:hover {
		cursor: pointer;
	}
`;